function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultSchema } from './schema';

var multipleInstances = function multipleInstances(element) {
  return document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]")).length > 1;
};

var collectCheckedOptions = function collectCheckedOptions(element) {
  return Array.from(element.querySelectorAll('option:checked')).concat(Array.from(document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]"))).filter(function (elem) {
    return elem.checked;
  })).map(function (o) {
    return o.value;
  });
}; // Returns a string value for the passed array.
//
//   attributeValue(['', 'one', null, 'two', 'three ']) // 'one two three'
//


export var attributeValue = function attributeValue() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = values.filter(function (v) {
    return v && String(v).length;
  }).map(function (v) {
    return v.trim();
  }).join(' ').trim();
  return value.length ? value : null;
}; // Returns an array for the passed string value by splitting on whitespace.
//
//   attributeValues('one two three ') // ['one', 'two', 'three']
//

export var attributeValues = function attributeValues(value) {
  if (!value) return [];
  if (!value.length) return [];
  return value.split(' ').filter(function (v) {
    return v.trim().length;
  });
}; // Extracts attributes from a DOM element.
//

export var extractElementAttributes = function extractElementAttributes(element) {
  var attrs = Array.from(element.attributes).reduce(function (memo, attr) {
    memo[attr.name] = attr.value;
    return memo;
  }, {});
  attrs.checked = !!element.checked;
  attrs.selected = !!element.selected;
  attrs.tag_name = element.tagName;

  if (element.tagName.match(/select/i) || multipleInstances(element)) {
    var collectedOptions = collectCheckedOptions(element);
    attrs.values = collectedOptions;
    attrs.value = collectedOptions.join(',');
  } else {
    attrs.value = element.value;

    if (element.tagName.match(/select/i)) {
      if (element.selectedIndex > -1) {
        attrs.value = element.options[element.selectedIndex].value;
      }
    }
  }

  return attrs;
}; // Extracts the dataset of an element and combines it with the data attributes from all parents if requested.
//

export var extractElementDataset = function extractElementDataset(element) {
  var datasetAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var attrs = extractDataAttributes(element) || {};
  var dataset = datasetAttribute && element.attributes[datasetAttribute];

  if (dataset && dataset.value === 'combined') {
    var parent = element.parentElement;

    while (parent) {
      attrs = _objectSpread(_objectSpread({}, extractDataAttributes(parent)), attrs);
      parent = parent.parentElement;
    }
  }

  return attrs;
}; // Extracts all data attributes from a DOM element.
//

export var extractDataAttributes = function extractDataAttributes(element) {
  var attrs = {};

  if (element && element.attributes) {
    Array.from(element.attributes).forEach(function (attr) {
      if (attr.name.startsWith('data-')) {
        attrs[attr.name] = attr.value;
      }
    });
  }

  return attrs;
}; // Finds an element based on the passed represention of the DOM element's attributes.
//
// NOTE: This is the same set of attributes extrated via extractElementAttributes and forwarded to the server side reflex.
// SEE: stimulate()
// SEE: StimulusReflex::Channel#broadcast_morph
// SEE: StimulusReflex::Channel#broadcast_error
//

export var findElement = function findElement(attributes) {
  attributes = attributes || {};
  var elements = [];

  if (attributes.id) {
    elements = document.querySelectorAll("#".concat(attributes.id));
  } else {
    var selectors = [];

    for (var key in attributes) {
      if (key.includes('.')) continue;
      if (key === 'tagName') continue;
      if (key === 'value') continue;
      if (key === 'values') continue;
      if (key === 'checked') continue;
      if (key === 'selected') continue;
      if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
      selectors.push("[".concat(key, "=\"").concat(attributes[key], "\"]"));
    }

    try {
      elements = document.querySelectorAll(selectors.join(''));
    } catch (error) {
      console.error('StimulusReflex encountered an error identifying the Stimulus element. Consider adding an #id to the element.', error, attributes);
    }
  }

  var element = elements.length === 1 ? elements[0] : null;
  return element;
};